<template>
  <div class="exchange-Add">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="商品名称：" prop="productName">
        <el-input v-model="form.productName"></el-input>
      </el-form-item>
      <el-form-item label="需要积分：" prop="exchangeIntegral">
        <el-input v-model="form.exchangeIntegral"></el-input>
      </el-form-item>
      <el-form-item label="产品介绍：" prop="productIntroduce">
        <el-input v-model="form.productIntroduce"></el-input>
      </el-form-item>
      <el-form-item label="排序：" prop="productSort">
        <el-input v-model="form.productSort"></el-input>
         </el-form-item>
      <el-form-item label="商品图片：" class="uploadImg">
        <upload
          :url="form.productUrl"
          @successUpload="handleSuccessUpload"
          prompt="上传封面图片：大小不超过2M，支持Jpeg、Jpg、Png格式，建议上传236*236尺寸。"
        />
      </el-form-item>
      <el-form-item class="submit">
        <el-button
          type="primary"
          :loading="loading"
          @click="onSubmit('form')"
        >保存</el-button>
        <el-button @click="handleCancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getExchangeProduct, updateExchangeProduct } from '@/api/exchange';
import Upload from '@/components/Upload/index.vue';
import { validCurrency } from '@/utils/validate';

export default {
  name: 'ExchangeAdd',
  data() {
    const validNumber = (rule, value, callback) => {
      if (validCurrency(value)) {
        callback();
      } else {
        callback(new Error('请输入正确数字值!'));
      }
    };
    return {
      loading: false,
      form: {
        id: '',
        productName: '',
        exchangeIntegral: '',
        productIntroduce: '',
        productSort: '',
        productUrl: '',
      },
      rules: {
        productName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
        exchangeIntegral: [
          { required: true, message: '积分不能为空', trigger: 'blur' },
          { validator: validNumber, trigger: 'blur' },
        ],
        productIntroduce: [
          { required: true, message: '请输入商品介绍信息', trigger: 'blur' },
        ],
        productSort: [
          { required: true, message: '排序不能为空', trigger: 'blur' },
          { validator: validNumber, trigger: 'blur' },
        ],
      },
    };
  },
  components: {
    Upload,
  },
  mounted() {
    this.getExchangeProduct();
  },
  methods: {
    // 获取商品信息
    getExchangeProduct() {
      const { id } = this.$route.query;
      getExchangeProduct(id).then((res) => {
        if (res.success) {
          const { createTime, ...rest } = res.data;
          this.form = rest;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 添加兑换商品
    updateExchangeProduct() {
      this.loading = true;
      updateExchangeProduct(this.form).then((res) => {
        if (res.success) {
          this.loading = false;
          this.$message.success('编辑成功');
          this.$router.push({ name: 'ExchangeList' });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { productUrl } = this.form;
          if (!productUrl) {
            this.$message.warning('请选择上传商品图片');
          } else {
            this.updateExchangeProduct();
          }
        }
        return false;
      });
    },
    handleSuccessUpload(url) {
      this.form.productUrl = url;
    },
    handleCancel() {
      this.$router.push({
        name: 'ExchangeList',
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.exchange-Add
  padding-top 80px
  .el-form
    width 700px
    margin 0 auto
    .uploadImg
      flex-row()
      >>>.el-form-item__content
        margin-left 0 !important
    .submit
      text-align center
</style>
